import { ProgramTypeOption } from "../types.graphql"
import { cn } from "./tw"

export const PROGRAM_TYPE_COLOR = {
  MFF: cn("bg-blue"),
  GEMS: cn("bg-purple"),
  CubanCinemaSeries: cn("bg-yellow"),
  MembersOnly: cn("bg-red"),
  CineClub: cn("bg-red-light"),
} as { [K in ProgramTypeOption]?: string }
